import React, { useState } from 'react';

const Dropdown = ({ label, items, icon }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleToggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  return (
    <div className={`dropdown ${isDropdownOpen ? 'show' : ''}`}>
      <p
        className={`text-muted ml-3 mt-1 d-flex justify-content-start align-items-center dropdown-toggle `}
        onClick={handleToggleDropdown}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
      >
        <i
          className={`${icon} font-20 mr-1 u_icon `}
          style={{ color: '#A6AEBF' }}
        ></i>
        {label}
      </p>
      <div className={`dropdown-menu`} aria-labelledby="dropdownMenu2">
        {items.map((item, index) => (
          <button key={index} className="dropdown-item" type="button">
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Dropdown;
